import { ASSETS } from '../assets'

type Props = {
  label?: string
  onClick?: () => void
  className?: string
  type?: 'default' | 'success' | 'warning' | 'error'
  isButtonDisabled?: boolean
}

export default function OptionButton({
  label = '',
  onClick,
  className = '',
  type = 'default',
  isButtonDisabled = false,
}: Props) {
  const isDisabled = type !== 'default' || isButtonDisabled

  const variant = {
    default:
      'border-white text-white bg-transparent cursor-pointer hover:bg-white/10 active:bg-white/10',
    success: 'border-[#009A4E] bg-[#009A4E] text-white cursor-not-allowed',
    warning: 'border-[#EB6200] text-[#EB6200] cursor-not-allowed',
    error: 'border-[#DA1E28] text-[#DA1E28] cursor-not-allowed',
  }[type]

  const leftIcon = () => {
    switch (type) {
      case 'success':
        return (
          <img
            src={ASSETS.iconCorrect}
            alt="correct"
            className="mr-4 inline-block h-14 w-14 shrink-0"
          />
        )
      case 'warning':
        return (
          <img
            src={ASSETS.iconIncorrectWarning}
            alt="warning"
            className="mr-4 inline-block h-14 w-14 shrink-0"
          />
        )
      case 'error':
        return (
          <img
            src={ASSETS.iconIncorrectDanger}
            alt="error"
            className="mr-4 inline-block h-14 w-14 shrink-0"
          />
        )
      default:
        return (
          <span
            aria-hidden
            className="mr-4 inline-block h-14 w-14 shrink-0 rounded-full bg-white"
          />
        )
    }
  }

  return (
    <button
      type="button"
      disabled={isDisabled}
      aria-disabled={isDisabled}
      onClick={!isDisabled ? onClick : undefined}
      className={[
        'relative inline-flex items-center text-left transition-colors',
        'min-h-18 min-w-91',
        'py-1 pr-6 pl-2',
        'rounded-full border-2',
        variant,
        isDisabled ? 'pointer-events-none' : '',
        className,
      ].join(' ')}
    >
      {leftIcon()}
      <span className="text-[30px] leading-[30px] font-normal">{label}</span>
    </button>
  )
}
